import CustomTextField from "./CustomTextField";
import React from "react";
import PropTypes from "prop-types";
import {isValidPhoneNumber} from "react-phone-number-input";
import {phoneFormatError} from "../../resources/environment";
import {useFormContext, useFormState} from "react-hook-form";

const CustomPhoneField = ({
  label,
  name,
  guide,
  hideErrors,
  defaultValue,
  customOptionality,
  helperText,
}) => {
  const formMethods = useFormContext();
  const {errors} = useFormState();

  const validatePhone = (value) => {
    formMethods.clearErrors();
    const isValid = !value || (value && isValidPhoneNumber(value));
    if (!isValid) {
      formMethods.setError(name, {type: "custom", message: phoneFormatError});
    } else {
      formMethods.clearErrors(name);
    }
    return isValid;
  };

  return (
    <CustomTextField
      label={label}
      name={name}
      guide={guide}
      hideErrors={hideErrors}
      defaultValue={defaultValue}
      customOptionality={customOptionality}
      validate={validatePhone}
      error={Boolean(!hideErrors && errors && errors[name])}
      errorText={phoneFormatError}
      helperText={helperText}
    />
  );
};

CustomPhoneField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  guide: PropTypes.string,
  hideErrors: PropTypes.bool,
  defaultValue: PropTypes.string,
  customOptionality: PropTypes.string,
  helperText: PropTypes.string,
};

export default CustomPhoneField;
